import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { MediclaimService } from "./mediclaim.service";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { IMediclaim } from "./imediclaim";

@Injectable({
    providedIn: 'root'
})
export class MediclaimResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(private _mediclaimService: MediclaimService) {
    }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, mediclaims: IMediclaim[] }>> {
        var data = {
            pageNumber: 0,
            pageSize: 100,
        };
        return this._mediclaimService.getMediclaimPlan(data);
    }
}